/* global axios */
import ApiClient from './ApiClient';

class BillingAPI extends ApiClient {
  constructor() {
    super('billing', { accountScoped: true });
  }

  getAvailablePlans() {
    return axios.get(`${this.url}/available_plans`);
  }

  upgradeSubscription(planCode, paymentProvider = null) {
    return axios.post(`${this.url}/upgrade_subscription`, {
      plan_code: planCode,
      ...(paymentProvider ? { payment_provider: paymentProvider } : {}),
    });
  }

  downgradeSubscription(planCode) {
    return axios.post(`${this.url}/downgrade_subscription`, {
      plan_code: planCode,
    });
  }

  getBillingStatus() {
    return axios.get(`${this.url}/billing_status`);
  }

  syncBillingCustomers() {
    return axios.post(`${this.url}/sync_billing_customers`);
  }

  getCustomerPortalUrl() {
    return axios.get(`${this.url}/customer_portal_url`);
  }
}

export default new BillingAPI();
